import { UserPreferenceContext } from '@contexts/user-preference-context';
import { PreivewContext } from '@modules/preview/contexts';
import MenuItem from '@navigation/menu-item';
import { useContext } from 'react';
import { ApplicationType } from '@testsigma/organism';

interface TestCaseMenuProps {
  showChildrenWithText?: boolean;
  isPreview?: boolean;
}

interface TestWritingMenuItemPros {
  lIcon: string;
  displayText: string;
  url: string;
  urlMatcherRegex: RegExp;
  canAccess: boolean;
  displayLink: boolean;
}

const TestWritingMenu: React.FC<TestCaseMenuProps> = (props) => {
  const { isPreview = false } = props;
  const {savePoint} = useContext(PreivewContext)
  const projectPreference = useContext(UserPreferenceContext)?.userPreference
    ?.preference?.projectPreference;

  const testWritingMenuItemPros: TestWritingMenuItemPros[] = [
    {
      lIcon: '',
      displayText: 'left.nav.testcase',
      url: isPreview ? 'cases/filters' : 'td/cases',
      urlMatcherRegex: isPreview
        ? new RegExp(/preview\/(\d+)\/cases|preview\/cases/g)
        : new RegExp(/td\/(\d+)\/cases|td\/cases/g),
      canAccess: true,
      displayLink: true,
    },
    {
      lIcon: '',
      displayText: 'left.nav.step_group',
      url: isPreview ? 'step-groups/filters' : 'td/step-groups',
      urlMatcherRegex: isPreview
        ? new RegExp(/preview\/(\d+)\/step-groups|preview\/step-groups/g)
        : new RegExp(/td\/(\d+)\/step-groups|td\/step-groups/g),
      canAccess: true,
      displayLink: true,
    },
    ...(savePoint?.applicationVersion?.application?.applicationType !==
    ApplicationType.Rest
      ? [
          {
            lIcon: '',
            displayText: 'left.nav.elements',
            url: isPreview ? `elements/filters` : 'td/elements',
            urlMatcherRegex: isPreview
              ? new RegExp(/preview\/(\d+)\/elements/g)
              : new RegExp(/td\/(\d+)\/elements/g),
            canAccess: !projectPreference?.selectedVersion?.application?.isRest,
            displayLink: true,
          },
        ]
      : []),
  ];

  return (
    <>
      {testWritingMenuItemPros.map((item) => {
        return (
          item?.canAccess && (
            <MenuItem
              key={item?.displayText}
              isLeftIcon={item.lIcon}
              itemKey={item?.displayText}
              navUrl={
                window.location.pathname.includes(item?.url) ? '' : item?.url
              }
              showWithText={props.showChildrenWithText}
              urlMatcherRegex={item?.urlMatcherRegex}
              isChild={true}
              displayLink={item?.displayLink}
            />
          )
        );
      })}
    </>
  );
};

export default TestWritingMenu;
